import FieldEditor from "editor/FieldEditor";

class FieldEditorWysiwyg extends FieldEditor {
    static update_default_link_target() {
        if (!window.CKEDITOR) return;
        window.CKEDITOR.on('dialogDefinition', function (ev) {
            try {
                if (ev.data.name === 'link') {
                    let informationTab = ev.data.definition.getContents('target');

                    let targetField = informationTab.get('linkTargetType');
                    targetField['default'] = '_blank';
                }
            } catch (e) {
                console.log("Couldn't update default link target", e);
            }
        });
    }

    create() {
        this.$element.attr("contenteditable", true).addClass("editing");

        const settings = this.settings;
        const ckeditorOptions = {
            removePlugins: [],
            extraPlugins: []
        };

        if (settings['noFormatting']) {
            ckeditorOptions['formatTags'] = 'a';
            ckeditorOptions['enterMode'] = CKEDITOR.ENTER_BR;
            ckeditorOptions['allowedContent'] = 'a[!href,target]';
            ckeditorOptions['removePlugins'].push('clipboard,notification,toolbar,pastetext');
        } else if (settings['allowedTags']) {
            ckeditorOptions['allowedContent'] = settings['allowedTags'];
        } else {
            ckeditorOptions['allowedContent'] = FieldEditorWysiwyg.DEFAULT_TAGS;
        }

        if (settings['singleParagraph']) {
            ckeditorOptions['enterMode'] = CKEDITOR.ENTER_BR;
        }

        if (settings['noToolbar']) {
            ckeditorOptions['removePlugins'].push('clipboard,notification,toolbar,pastetext');
        }

        if (settings['noImages'] === true) {
            ckeditorOptions['toolbar'] = 'no-images';
        }
        if (settings['removePlugins']) {
            if ($.isArray(settings['removePlugins'])) {
                ckeditorOptions['removePlugins'] = ckeditorOptions['removePlugins'].concat(settings['removePlugins']);
            } else {
                ckeditorOptions['removePlugins'].push(settings['removePlugins']);
            }
        }
        if (settings['extraPlugins']) {
            if ($.isArray(settings['extraPlugins'])) {
                ckeditorOptions['extraPlugins'] = ckeditorOptions['extraPlugins'].concat(settings['extraPlugins']);
            } else {
                ckeditorOptions['extraPlugins'].push(settings['extraPlugins']);
            }
        }
        if (settings['baseFloatZIndex']) {
            ckeditorOptions['baseFloatZIndex'] = settings['baseFloatZIndex'];
        }
        if (settings['maxLength']) {
            ckeditorOptions.wordcount = {
                showCharCount: true,
                showWordCount: false,
                showParagraphs: false,
                maxCharCount: settings['maxLength']
            };
        } else {
            ckeditorOptions['removePlugins'].push("wordcount");
        }
        ckeditorOptions['removePlugins'] = ckeditorOptions['removePlugins'].join(",");
        ckeditorOptions['extraPlugins'] = ckeditorOptions['extraPlugins'].join(",");

        if (this.settings.inline) {
            this.editor = CKEDITOR.inline(this.$element[0], ckeditorOptions);
        } else {
            this.editor = CKEDITOR.replace(this.$element[0], ckeditorOptions);
        }

        this.editor.on("change", () => this.emit('change', this.getValue()));

        setTimeout(() => this.emit('ckeditorInit', this.editor))
    }

    destroy() {
        super.destroy();

        let value = this.getValue();
        this.editor.destroy();
        this.editor = null;
        this.$element.removeClass("editing").removeAttr("contenteditable").html(value);
    }

    getValue() {
        return this.editor.getData().trim();
    }

    setValue(value) {
        this.editor.setData(value);
    }
}

FieldEditor.register_editor("wysiwyg", FieldEditorWysiwyg);

FieldEditorWysiwyg.update_default_link_target();

FieldEditorWysiwyg.DEFAULT_TAGS = 'a[!href,target]; h2 h3 h4 h5 p blockquote strong em ul ol li table thead tbody tr td th';

export default FieldEditorWysiwyg;
